"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../../hooks");
const providers_1 = require("../../../providers");
const colors_1 = require("../../../utils/colors");
function ColorFormatButton({ color, strokeColor }) {
    const [{ foreColor }, dispatch] = (0, providers_1.useRichTextContext)();
    const handleClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        (0, hooks_1.setTextStyle)(hooks_1.TextStyle.ForeColor, color);
        dispatch((0, hooks_1.updateTextStyles)());
    };
    return ((0, jsx_runtime_1.jsx)(Button, { onClickCapture: handleClick, type: "button", "data-e2e": 'ColorFormatButton_Button', children: (0, jsx_runtime_1.jsx)(StyledIcon, { active: color === (0, colors_1.rgb2hex)(foreColor), name: ui_1.Icons.Formatting_Text_Color, color: color, width: 30, height: 30, stroke: strokeColor, "data-e2e": 'ColorFormatButton_StyledIcon' }) }));
}
exports.default = ColorFormatButton;
const Button = styled_components_1.default.button `
  display: flex;
  align-items: center;
  margin: 0 10px;
  padding: 0;

  background: none;
  border: none;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  background-color: ${({ theme, active }) => active ? theme.white : theme.white_50};
  border-radius: 50%;
  transition: background-color, transform 0.2s;

  ${({ stroke }) => stroke &&
    `
    fill: none;
    stroke: ${stroke};
  `};

  :active {
    transform: scale(0.9, 0.9);
  }
`;
